import { createContext } from 'react';

/**
 * Theme is light-locked (gpm pattern): the type space allows only `'light'`
 * until a real dark theme ships, at which point this widens without callers
 * changing shape.
 */
type Theme = 'light';

export interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  resolvedTheme: 'light';
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
